import type { UpcomingInvoicesReportItem } from '@vy/types';
import { isNotEmptyArray } from '@vy/utils';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { matchesStringSelection } from '../../reports-components/shared-filter-fields';
import { BILLING_FORECAST_FILTER_FIELD_IDS } from '../hooks/use-billing-forecast-filter-fields';

type FilterPredicate = (item: UpcomingInvoicesReportItem, value: unknown) => boolean;

const FIELD_PREDICATES: Record<string, FilterPredicate> = {
  [BILLING_FORECAST_FILTER_FIELD_IDS.CustomerId]: (item, value) =>
    matchesStringSelection(item.customer.id, value),

  [BILLING_FORECAST_FILTER_FIELD_IDS.ContractStatus]: (item, value) =>
    matchesStringSelection(item.contract.status, value),

  [BILLING_FORECAST_FILTER_FIELD_IDS.ReviewStatus]: (item, value) =>
    item.invoices.some((invoice) => matchesStringSelection(invoice.reviewStatus, value)),

  [BILLING_FORECAST_FILTER_FIELD_IDS.BillingStatus]: (item, value) =>
    item.invoices.some((invoice) => matchesStringSelection(invoice.billingStatus, value)),
};

export function applyBillingForecastFilters(
  reportItems: UpcomingInvoicesReportItem[],
  filters: FilterLineType[],
): UpcomingInvoicesReportItem[] {
  if (!isNotEmptyArray(filters)) {
    return reportItems;
  }

  return reportItems.filter((item) =>
    filters.every((filter) => {
      const predicate = FIELD_PREDICATES[filter.field];

      if (!predicate) {
        return true;
      }

      return predicate(item, filter.value);
    }),
  );
}
